<div class="home-container">
  <div class="home-header">
    <!-- Logo: To replace with actual logo, download the image from https://force.valumre.com/login 
         and save it as src/assets/logo.png or src/assets/logo.svg, then update the src attribute below -->
    <img src="assets/logo-tasafy.png" alt="Tasafy Logo" class="logo" />
    <h1>Tasafy - Acciones Masivas</h1>
    <p>Selecciona la acción masiva que deseas realizar</p>
  </div>
  
  <div class="actions-list">
    <div 
      *ngFor="let action of massiveActions" 
      class="action-card"
      (click)="navigateTo(action.route)"
    >
      <h2>{{ action.title }}</h2>
      <p>{{ action.description }}</p>
      <div class="card-arrow">→</div>
    </div>
  </div>
</div>
